import React, { useState, useEffect } from "react";
import {
  TextField,
  Button,
  Grid,
  MenuItem,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Fab,
  Tooltip,
  Typography,
  CircularProgress,
} from "@mui/material";

import AddOutlinedIcon from "@mui/icons-material/AddOutlined";
import { useDispatch, useSelector } from "react-redux";
import { addLead } from "../Minicrm/Redux/Slice/LeadSlice";

const categories = [
  "Stock Market",
  "Crypto",
  "Real Estate",
  "Business",
  "Technology",
];

const LeadForm = () => {
  const dispatch = useDispatch();
  const { loading, error } = useSelector(
    (state) => state?.leads || { loading: false, error: null }
  );

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    mobile: "",
    category: "",
    partnerId: "",
  });

  const [open, setOpen] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");

  useEffect(() => {
    const user = JSON.parse(sessionStorage.getItem("user"));
    if (user && user?.userId) {
      setFormData((prev) => ({ ...prev, partnerId: user?.userId }));
    }
  }, []);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    dispatch(addLead(formData));

    // Show success message
    setSuccessMessage("Lead added successfully!");

    // Reset form & close modal after 2 seconds
    setTimeout(() => {
      setSuccessMessage("");
      setFormData({
        name: "",
        email: "",
        mobile: "",
        category: "",
        partnerId: formData.partnerId,
      });
      setOpen(false);
    }, 2000);
  };

  return (
    <>
      {/* Floating Button to Open Form */}
      <Tooltip title="Add New Lead">
        <Fab
          color="primary"
          sx={{ position: "fixed", bottom: 40, right: 10 }}
          onClick={() => setOpen(true)}
        >
          <AddOutlinedIcon sx={{ fontSize: 40, fontWeight: "bold" }} />
        </Fab>
      </Tooltip>

      {/* Lead Form Modal */}
      <Dialog
        open={open}
        onClose={() => setOpen(false)}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle sx={{ textAlign: "center", fontWeight: "550" }}>
          Add New Lead
        </DialogTitle>
        <DialogContent>
          {successMessage && (
            <Typography color="green" textAlign="center" sx={{ mb: 2 }}>
              {successMessage}
            </Typography>
          )}
          {error && (
            <Typography color="error" textAlign="center" sx={{ mb: 2 }}>
              {error}
            </Typography>
          )}
          <form onSubmit={handleSubmit}>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <TextField
                  fullWidth
                  label="Name"
                  name="name"
                  variant="outlined"
                  value={formData.name}
                  onChange={handleChange}
                  required
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  fullWidth
                  label="Email"
                  name="email"
                  type="email"
                  variant="outlined"
                  value={formData.email}
                  onChange={handleChange}
                  required
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  fullWidth
                  label="Mobile"
                  name="mobile"
                  type="tel"
                  variant="outlined"
                  value={formData.mobile}
                  onChange={handleChange}
                  required
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  fullWidth
                  select
                  label="Category"
                  name="category"
                  variant="outlined"
                  value={formData.category}
                  onChange={handleChange}
                  required
                >
                  {categories.map((option) => (
                    <MenuItem key={option} value={option}>
                      {option}
                    </MenuItem>
                  ))}
                </TextField>
              </Grid>
            </Grid>
          </form>
        </DialogContent>
        <DialogActions
          sx={{
            // justifyContent: "center",
            justifyContent: "space-between",
            pb: 3,
            pl: 3,
            pr: 3,
          }}
        >
          <Button
            onClick={() => setOpen(false)}
            variant="outlined"
            color="secondary"
            sx={{ textTransform: "capitalize" }}
          >
            Cancel
          </Button>
          <Button
            type="submit"
            variant="contained"
            color="primary"
            size="large"
            onClick={handleSubmit}
            disabled={loading}
            sx={{ textTransform: "capitalize" }}
          >
            {loading ? (
              <CircularProgress size={24} sx={{ color: "white" }} />
            ) : (
              "Submit"
            )}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default LeadForm;
